/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { NewspaperMaster } from '../model';
/**
 * NewspaperMasterApi - axios parameter creator
 * @export
 */
export const NewspaperMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [area] area
         * @param {string} [circulation] circulation
         * @param {string} [company] company
         * @param {string} [createdAt] created_at
         * @param {string} [distinct] Distinct QuerySet
         * @param {string} [id] id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [publicationForm] publication_form
         * @param {string} [search] A search term.
         * @param {string} [type] type
         * @param {string} [updatedAt] updated_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newspaperMasterList: async (area?: string, circulation?: string, company?: string, createdAt?: string, distinct?: string, id?: string, ordering?: string, publicationForm?: string, search?: string, type?: string, updatedAt?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/newspaper_master/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (circulation !== undefined) {
                localVarQueryParameter['circulation'] = circulation;
            }

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (createdAt !== undefined) {
                localVarQueryParameter['created_at'] = createdAt;
            }

            if (distinct !== undefined) {
                localVarQueryParameter['distinct'] = distinct;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (publicationForm !== undefined) {
                localVarQueryParameter['publication_form'] = publicationForm;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (updatedAt !== undefined) {
                localVarQueryParameter['updated_at'] = updatedAt;
            }


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this newspaper master.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newspaperMasterRetrieve: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling newspaperMasterRetrieve.');
            }
            const localVarPath = `/api/newspaper_master/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewspaperMasterApi - functional programming interface
 * @export
 */
export const NewspaperMasterApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [area] area
         * @param {string} [circulation] circulation
         * @param {string} [company] company
         * @param {string} [createdAt] created_at
         * @param {string} [distinct] Distinct QuerySet
         * @param {string} [id] id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [publicationForm] publication_form
         * @param {string} [search] A search term.
         * @param {string} [type] type
         * @param {string} [updatedAt] updated_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newspaperMasterList(area?: string, circulation?: string, company?: string, createdAt?: string, distinct?: string, id?: string, ordering?: string, publicationForm?: string, search?: string, type?: string, updatedAt?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewspaperMaster>>> {
            const localVarAxiosArgs = await NewspaperMasterApiAxiosParamCreator(configuration).newspaperMasterList(area, circulation, company, createdAt, distinct, id, ordering, publicationForm, search, type, updatedAt, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this newspaper master.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newspaperMasterRetrieve(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewspaperMaster>> {
            const localVarAxiosArgs = await NewspaperMasterApiAxiosParamCreator(configuration).newspaperMasterRetrieve(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NewspaperMasterApi - factory interface
 * @export
 */
export const NewspaperMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} [area] area
         * @param {string} [circulation] circulation
         * @param {string} [company] company
         * @param {string} [createdAt] created_at
         * @param {string} [distinct] Distinct QuerySet
         * @param {string} [id] id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [publicationForm] publication_form
         * @param {string} [search] A search term.
         * @param {string} [type] type
         * @param {string} [updatedAt] updated_at
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newspaperMasterList(area?: string, circulation?: string, company?: string, createdAt?: string, distinct?: string, id?: string, ordering?: string, publicationForm?: string, search?: string, type?: string, updatedAt?: string, options?: any): AxiosPromise<Array<NewspaperMaster>> {
            return NewspaperMasterApiFp(configuration).newspaperMasterList(area, circulation, company, createdAt, distinct, id, ordering, publicationForm, search, type, updatedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this newspaper master.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newspaperMasterRetrieve(id: string, options?: any): AxiosPromise<NewspaperMaster> {
            return NewspaperMasterApiFp(configuration).newspaperMasterRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NewspaperMasterApi - object-oriented interface
 * @export
 * @class NewspaperMasterApi
 * @extends {BaseAPI}
 */
export class NewspaperMasterApi extends BaseAPI {
    /**
     * 
     * @param {string} [area] area
     * @param {string} [circulation] circulation
     * @param {string} [company] company
     * @param {string} [createdAt] created_at
     * @param {string} [distinct] Distinct QuerySet
     * @param {string} [id] id
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [publicationForm] publication_form
     * @param {string} [search] A search term.
     * @param {string} [type] type
     * @param {string} [updatedAt] updated_at
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewspaperMasterApi
     */
    public newspaperMasterList(area?: string, circulation?: string, company?: string, createdAt?: string, distinct?: string, id?: string, ordering?: string, publicationForm?: string, search?: string, type?: string, updatedAt?: string, options?: any) {
        return NewspaperMasterApiFp(this.configuration).newspaperMasterList(area, circulation, company, createdAt, distinct, id, ordering, publicationForm, search, type, updatedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this newspaper master.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewspaperMasterApi
     */
    public newspaperMasterRetrieve(id: string, options?: any) {
        return NewspaperMasterApiFp(this.configuration).newspaperMasterRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}
